import PromiseHelper from "base/PromiseHelper";
import ScriptHelper from "base/ScriptHelper";

export default class GoogleLoginHelper {

    static async load_js() {
        try {
            return await (new Promise(async (resolve) => {
                await ScriptHelper.load_script("https://apis.google.com/js/platform.js");

                for (let i = 0; i < 20; i++) {
                    if (window.gapi && window.gapi.load) {
                        break;
                    }
                    console.warn("Google APIs not loaded, waiting");
                    await PromiseHelper.timed_promise(75);
                }

                window.gapi.load("auth2", resolve);
            }));
        } catch (e) {
            console.warn("Couldn't load google auth javascript", e);
            throw e;
        }
    }

    static async initialise(config) {
        await GoogleLoginHelper.load_js();

        window.gapi.auth2.init({
            client_id: config.clientId,
            scope: config.scopes.join(" "),
            fetch_basic_profile: true,
            hosted_domain: config.hostedDomain,
        });
    }

    static authorize() {
        return gapi.auth2.getAuthInstance().signIn();
    }
}
